<template>
	<div class="is-flex is-flex-direction-row mb-2">
		<o-skeleton rounded width="6em" height="6em"></o-skeleton>
		<div class="ml-5">
			<div class="is-flex is-flex-direction-row">
				<o-skeleton width="3em" style="margin-top: 0.5em"></o-skeleton>
				<o-skeleton width="3em"></o-skeleton>
			</div>
			<o-skeleton width="6em"></o-skeleton>
			<o-skeleton width="6em"></o-skeleton>
		</div>
	</div>
</template>
<script>
	export default {
		setup(props, context) {
			return {};
		}
	};
</script>